<template>
  <div class="home-container">
    <!-- 头部 banner 区域 -->
    <div  class="header-container">
      <div class="header-img">
        <div class="btn-link">
          <a target="_blank" class="now" @click="goAssignBlock('block8', speed, 8)"></a>
        </div>
        <!-- 大赛介绍 -->
        <div class="cp-introduction" id="match-introduction" ref="block1">
          <match-introduction/>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-container">
      <div class="main-content">
        <!-- 精彩视频 -->
        <div class="match-feature" ref="block2">
            <match-characteristic/>
        </div>
         <!-- 往届照片 -->
        <div class="wonderful-review" ref="block3">
            <wonderful-review/>
        </div>
        <!-- 赛事公告 -->
        <div class="match-notice" ref="block4">
            <match-notice/>
        </div>
        <!-- 赛程安排 -->
        <div class="match-plan" ref="block5">
            <match-plan/>
        </div>
        <!-- 报名说明 -->
        <div class="reg-instruction" ref="block6">
            <reg-instruction/>
        </div>
        <!-- 比赛形式 -->
        <div class="match-form">
            <match-form/>
        </div>
        <!-- 奖项设置 -->
        <div class="awards-setting" ref="block7">
          <awards-setting/>
        </div>
        <!-- 晋级名单 -->
        <div>
          <promotion-list/>
        </div>
        <!-- 决赛成绩 -->
        <div ref="block8">
          <final-result/>
        </div>
        <!-- 大赛组织 -->
        <div class="match-organization" ref="block9">
          <match-organization/>
        </div>
        <!-- 支持媒体 -->
        <div class="support-media" ref="block10">
          <support-media/>
        </div>
        <!-- 联系方式 -->
        <div class="contact-details" ref="block11">
          <contact-details/>
        </div>

        <!-- 底部区域 -->
        <div class="footer">
            <span class="footer-span">
              <a target="_blank" href="https://beian.miit.gov.cn/" rel="nofollow">京ICP备16020626号-8</a>
              <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002002064" style="display: inline-block" rel="nofollow">
                京公网安备11000002002064号
              </a>
            </span>
        </div>
      </div>
    </div>

    <!-- 导航栏区域 -->
    <div id="nav" class="nav-container" v-if="navFlag">
      <ul>
        <li v-for="(item, index) in newNavs"
            v-show="index != 4"
            :key="index"
            :class="{li_active: active === index}"
            @click="goAssignBlock('block' + index, speed, index)"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import MatchCharacteristic from '@components/business/match-characteristic'
import MatchNotice from '@components/business/match-notice.vue'
import MatchPlan from '@components/business/match-plan.vue'
import RegInstruction from '@components/business/reg-instruction.vue'
import MatchForm from '@components/business/match-form.vue'
import AwardsSetting from '@components/business/awards-setting.vue'
import MatchOrganization from '@components/business/match-organization.vue'
import SupportMedia from '@components/business/support-media.vue'
import ContactDetails from '@components/business/contact-details.vue'
import MatchIntroduction from '@components/business/match-introduction.vue'
import PromotionList from '@components/business/promotion-list.vue'
import FinalResult from '@components/business/final-result.vue'
import WonderfulReview from '../components/business/wonderful-review.vue'

export default {
  components: {
    MatchCharacteristic,
    MatchNotice,
    MatchPlan,
    RegInstruction,
    MatchForm,
    AwardsSetting,
    MatchOrganization,
    SupportMedia,
    ContactDetails,
    MatchIntroduction,
    PromotionList,
    FinalResult,
    WonderfulReview
  },
  name: 'Home',
  data () {
    return {
      navFlag: false,
      regUrl: 'https://www.ichunqiu.com/2021bluehat',
      // 被激活的li是否高亮
      active: '',
      // 导航栏奇安信下标
      qaxIndex: 0,
      // 导航栏 Top 下标
      topIndex: 12,
      // 置顶动画移动的速度
      speed: 150,
      newNavs: [
        {
          title: '奇安信官网',
          position: ''
        },
        {
          title: '大赛介绍',
          position: ''
        },
        {
          title: '精彩视频',
          position: ''
        },
        {
          title: '往届照片',
          position: ''
        },
        {
          title: '赛事公告',
          position: ''
        },
        {
          title: '赛程安排',
          position: ''
        },
        {
          title: '报名说明',
          position: ''
        },
        {
          title: '奖项设置',
          position: ''
        },
        {
          title: '决赛成绩',
          position: ''
        },
        {
          title: '大赛组织',
          position: ''
        },
        {
          title: '支持媒体',
          position: ''
        },
        {
          title: '联系方式',
          position: ''
        },
        {
          title: 'TOP',
          position: ''
        }
      ]
    }
  },
  mounted () {
    // 监听滚动事件
    // window.addEventListener('scroll', this.watchScroll)
    window.addEventListener('scroll', this.onScroll)
  },
  methods: {
    /**
     * @desc 点击导航高亮li, 并移动到相应位置
     * @param {number} speed - 移动到顶端的速度
     * @param {number} index - li 的下标
     */
    goAssignBlock (el, speed, index) {
      // 点亮被激活的li
      this.active = index
      // 跳转页面至官网
      if (index === this.qaxIndex) {
        window.open('https://www.qianxin.com/', '_blank')
        this.active = null
        return
      } else {
        // 置顶TOP
        if (index === this.topIndex) {
          var timer = null
          cancelAnimationFrame(timer)
          timer = requestAnimationFrame(function fn () {
            var oTop = document.documentElement.scrollTop || document.body.scrollTop
            if (oTop > 0) {
              document.body.scrollTop = document.documentElement.scrollTop = oTop - speed
              timer = requestAnimationFrame(fn)
            } else {
              cancelAnimationFrame(timer)
            }
          })
          this.active = ''
          return
        }
      }
      // 获取元素位置
      const top = this.getElementTop(this.$refs[el])
      // 跳转到相应的元素位置
      window.scrollTo(0, top)
    },
    /**
     * @desc 获取元素的高度
     */
    getElementTop (element) {
      let actualTop = element.offsetTop
      var current = element.offsetParent
      while (current) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }
      return actualTop
    },
    onScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 200) {
        this.navFlag = true
      } else {
        this.navFlag = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  position: relative;
  background-color: #02021c;
  min-width: 1280px;
  .cp-introduction {
    position: relative;
    width: 1150px;
    height: 294px;
    top: 550px;
    margin: 0 auto;
  }
  .header-container {
    width: 100%;
    height: 915px;
    margin-bottom: 20px;
    .header-img {
      height: 800px;
      background: url(../assets/images/bg_banner.jpeg) no-repeat center center;
      background-position-x: center;
      background-position-y: center;
    }
    .btn-link {
      position: relative;
      width: 170px;
      height: 53px;
      top: 540px;
      margin: 0 auto;
      a:first-child {
        bottom: REM(778);
        animation: bounceInDown 1s 0s linear forwards;
      }
    }
    .now {
      float: left;
      display: block;
      width: 170px;
      height: 53px;
      background: url(../assets/images/btn_promote.png) no-repeat top center;
      cursor: pointer;
    }
  }
  .footer {
    position: relative;
    bottom:0;
    width: 100%;
    background-color: #111731;
    height: 69px;
    .footer-span {
      display: block;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #5891FA;
      line-height: 69px;
      opacity: 0.5;
      a{
        color: #5891fa;
        margin-right:10px;
      }
    }
  }
}
.main-container {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #02021c;
  box-sizing: border-box;
  .wonderful-review {
    width: 1180px;
    margin: 0 auto;
  }
  .main-content {
    height: 100%;
    width: 100%;
    top: 15px;
    > div:not(:last-child) {
      margin-bottom: 50px;
    }
    span {
      display: block;
      height: 35px;
      line-height: 35px;
      text-align: center;
      color: white;
    }
  }
}
.nav-container {
  position: fixed;
  // display: flex;
  // align-items: center;
  top: 50vh;
  right: 20px;
  transform: translateY(-50%);
  ul{
    animation: bounceInRight .5s 0s linear forwards;
  }
  li {
    width: 75px;
    line-height: 30px;
    color:#5891FA;
    font-size: 7px;
    background-image: url(../assets/images/nav-li.png);
    background-size: 100%;
    text-align: center;
    cursor: pointer;
  }
  li:hover, .li_active {
    color: #E4BA3D;
    background-image: url(../assets/images/nav-li-active.png);
    background-size: 100%;
  }
  li:not(:last-child) {
    margin-bottom: 10px;
  }
}
@-webkit-keyframes bounceInDown {
  from, 60%, 75%, 90%, to {animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);}
  0% {opacity: 0;transform: translate3d(0, -200px, 0);}
  100% {opacity: 1;transform: none;}
}
@-webkit-keyframes bounceInRight {
  from, 60%, 75%, 90%, to {animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);}
  0% {opacity: 0;transform: translate3d(20px, 0, 0);}
  100% {opacity: 1;transform: none;}
}
</style>
